'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = 'M88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM504 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM161.4 136L184 158.6c8.1-8.1 14.6-14.6 19.6-19.6 23.1-23.1 37.7-53.4 41.3-85.9 2.2-20.2 3.8-34.6 4.8-43.3L217.9 6.3c-1 8.7-2.6 23.1-4.8 43.3-2.8 25.3-14.1 48.8-32.1 66.8-5 5-11.5 11.5-19.6 19.6zM364.7 316.7L353.4 328 376 350.6c8.1-8.1 14.6-14.6 19.6-19.6 18-18 41.6-29.3 66.8-32.1 20.2-2.2 34.6-3.8 43.3-4.8l-3.5-31.8c-8.7 1-23.1 2.6-43.3 4.8-32.5 3.6-62.8 18.2-85.9 41.3l-8.3 8.2zM510.6 25.9L489.9 1.5c-8.5 7.2-15.9 13.5-22.2 18.8-7.3 6.2-16.6 9.4-26.1 9.2-38.2-1-70.4 28.5-72.6 66.6l-1.8 30c-1.2 20.9-18.8 37.1-39.8 36.5-17.4-.5-34.4 5.5-47.7 16.7-6.3 5.3-13.7 11.6-22.2 18.8l20.7 24.4c8.5-7.2 15.9-13.5 22.2-18.8 7.3-6.2 16.6-9.4 26.1-9.2 38.2 1 70.4-28.5 72.6-66.6l1.8-30c1.2-20.9 18.8-37.1 39.8-36.5 17.4 .5 34.4-5.5 47.7-16.7 6.3-5.3 13.7-11.6 22.2-18.8zM39.9 474.6l-2.5-2.5 25.8-66.3 43 43-66.3 25.8zm147-57.2l-48.1 18.7-62.9-62.9 18.7-48.1 92.3 92.3zM107.3 292.7l-.1-.1 16.8-43.3 138.6 138.6-43.3 16.8-.1-.1-112-112zm-8-68.1L0 480 32 512 287.4 412.7 320 400 295.3 375.3 136.7 216.7 112 192 99.3 224.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;